<template>
  <div>
    <input-group label="Name" placeholder="Enter template name" v-model="name" />
    <message-section v-model="message" :isTemplate=true />
    <div class="message-button message-button-primary" @click="submitTemplate">
      SAVE TEMPLATE
    </div>
  </div>
</template>

<script>
import MessageSection from "@/views/PushNotification/Components/Message";
import InputGroup from "@/views/PushNotification/UIComponents/InputGroup";
import notify from "@/util/notification";

export default {
  name: "Template",
  components: {
    MessageSection,
    InputGroup
  },
  computed: {
    templates() {
      return this.$store.getters.templateMessages
    }
  },
  watch: {
    templates: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if(newVal.length > 0 && this.$route.params.id) {
          const editTemplate = this.templates.find(template => template.id === this.$route.params.id)
          this.name = editTemplate.name
          this.message = editTemplate.messages[0]
        }
      }
    }
  },
  data() {
    return {
      name: "",
      status: "template",
      message: {
        messageBody: {
          default: {
            title: "Title",
            subtitle: "Subtitle",
            body: "Message"
          }
        },
        platformSettings: {
          badges: "dontSet",
          badgeCount: "0",
          sound: "default",
          mutableContent: false
        },
        otherSettings: {
          additionalData: [],
          timeToLive: "",
          actionButtons: []
        }
      }
    }
  },
  methods: {
    submitTemplate() {
      let isNameExists = false;
      this.templates.forEach(template => {
        if(template.name == this.name){
          isNameExists = true
        }
      });
      if(!this.name) {
        return notify("Name field cannot be empty!", "error")
      }
      if(this.$route.params.id) {
        this.editTemplate()
      } else {
        if(isNameExists){
          return notify("Template with same name already exists!", "error")
        }
        this.addTemplate()
      }
    },
    addTemplate() {
      const payload = {
        name: this.name,
        status: 'template',
        messages: [
          this.message
        ]
      }
      this.$store.dispatch('configAdd', {type: 'message', payload}).then(() => {
        this.$router.push({name: 'MessagesTemplates'})
      })
    },
    editTemplate() {
      const data = {
        name: this.name,
        status: 'template',
        messages: [
          this.message
        ]
      }
      const payload = { id: this.$route.params.id, data }
      this.$store.dispatch('configEdit', {type: 'message', payload}).then(() => {
        this.$router.push({name: 'MessagesTemplates'})
      });
    }
  }
}
</script>

<style scoped>
.message-button {
  padding: 15px 25px;
  margin: 0 10px;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
}
.message-button-primary {
  padding: 5px 10px;

  margin: 10px 0;
  background: #BB86FC;
  color: white;
  display: inline-block;
}
</style>